import React from "react";
import S from './EvoIndustry.module.scss';
import evoIndustry from '../../shared/assets/images/EVO.INDUSTRY.jpg'
import {useNavigate} from "react-router-dom";
import backgroundForCompany1 from '../../shared/assets/images/backgroundForCompany1.png';
import backgroundForCompany2 from '../../shared/assets/images/backgroundForCompany2.png';

export const EvoIndustry = () => {
    const navigate = useNavigate();
    return (
        <div className={S.evoIndustry} id='about'>
            <div className={S.backgroundForCompany1}>
                <img src={backgroundForCompany1} alt="backgroundForCompany1"/>
            </div>
            <div className={S.content}>
                <div className={S.contentDiv}>
                    <div className={S.infoDiv}>
                        <div>
                            <div className={S.title}>О компании</div>
                            <div className={S.textDescription}>Организатор, миссия, формат</div>
                        </div>
                        <div className={S.text}>
                            <span>ООО «ЭВОФОРУМ»</span> специализируется на проведении закрытых деловых форумов для
                            предприятий энергетики, машиностроения, ГМК, нефтегазовой и химической отраслей. Это
                            площадка,
                            где в формате содержательных докладов и презентаций демонстрируются реальные кейсы,
                            стратегии и
                            технологические решения, планируемые и уже внедрённые в ведущих промышленных компаниях.
                        </div>
                        <button className={S.button} onClick={() => navigate('/about-company')}>ПОДРОБНЕЕ</button>
                    </div>
                    <div className={S.picture}>
                        <img src={evoIndustry} alt="evoIndustry"/>
                    </div>
                </div>
            </div>
            <div className={S.backgroundForCompany2}>
                <img src={backgroundForCompany2} alt="backgroundForCompany2"/>
            </div>
        </div>
    );
};